import { Component, OnInit , CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-mobile-search-list',
    templateUrl: './mobile-search-list.component.html',
    styleUrls: ['./mobile-search-list.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class MobileSearchListComponent implements OnInit {
    constructor(private popoverController: PopoverController) {}

    ngOnInit() {
        /* empty */
    }

    order(event: any) {
        this.popoverController.dismiss({ order: event });
    }
}
